import { render, staticRenderFns } from "./exhibition-release-new-await.vue?vue&type=template&id=b066a040&scoped=true&"
import script from "./exhibition-release-new-await.vue?vue&type=script&lang=js&"
export * from "./exhibition-release-new-await.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b066a040",
  null
  
)

export default component.exports